<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card class="mt-4 agency-contest">
		<v-card-title>
			<h2>Parametry naboru</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-btn class="mt-3 ml-3" color="primary save-button" dark @click="save">Zapisz zmiany</v-btn>
		<v-card-text>
			<v-layout class="pt-3">
				<v-flex xs6>
					<v-layout class="mt-2" row wrap>
						<v-flex xs3>
							<v-subheader>Pełna nazwa naboru</v-subheader>
						</v-flex>
						<v-flex xs8>
							<v-text-field
								browser-autocomplete="off"
								label="Pełna nazwa naboru"
								aria-label="full contest name"
								for="agency-contest-main-data-full-name-application"
								id="agency-contest-main-data-full-name-application"
								v-model="contestData.name"
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row wrap>
						<v-flex xs3>
							<v-subheader>Skrócona nazwa naboru</v-subheader>
						</v-flex>
						<v-flex xs8>
							<v-text-field
								:disabled="!contestData.new"
								browser-autocomplete="off"
								label="Skrócona nazwa naboru"
								aria-label="short contest name"
								for="agency-contest-main-data-short-name-application"
								id="agency-contest-main-data-short-name-application"
								v-model="contestData.shortName"
							></v-text-field>
						</v-flex>
					</v-layout>

					<v-layout row wrap>
						<v-flex xs3>
							<v-subheader>Początek naboru wniosków</v-subheader>
						</v-flex>
						<v-flex xs4>
							<v-menu
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="contestData.contestStartDate"
								full-width
								lazy
								min-width="290px"
								offset-y
								ref="contestStartDateMenu"
								transition="scale-transition"
								v-model="contestStartDateMenu"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										browser-autocomplete="off"
										label="Data rozpoczęcia naboru wniosków"
										aria-label="contest start date"
										for="agency-contest-main-data-date-start-recruitment"
										id="agency-contest-main-data-date-start-recruitment"
										prepend-icon="event"
										readonly
										v-model="contestData.contestStartDate"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									no-title
									scrollable
									:first-day-of-week="1"
									v-model="contestData.contestStartDate"
									locale="pl-PL"
								>
									<v-spacer></v-spacer>
									<v-btn @click="contestStartDateMenu = false" color="primary" flat>Powrót</v-btn>
									<v-btn
										@click="$refs.contestStartDateMenu.save(contestData.contestStartDate)"
										color="blue"
									>OK
									</v-btn>
								</v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex xs4>
							<v-menu
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="contestData.contestStartTime"
								full-width
								lazy
								max-width="290px"
								min-width="290px"
								offset-y
								ref="contestStartTimeMenu"
								transition="scale-transition"
								v-model="contestStartTimeMenu"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										browser-autocomplete="off"
										label="Czas rozpoczęcia naboru wniosków"
										aria-label="contest start time"
										for="agency-contest-main-data-time-start-recruitment"
										id="agency-contest-main-data-time-start-recruitment"
										prepend-icon="access_time"
										readonly
										v-model="contestData.contestStartTime"
										v-on="on"
									></v-text-field>
								</template>
								<v-time-picker
									@click:minute="$refs.contestStartTimeMenu.save(contestData.contestStartTime)"
									format="24hr"
									full-width
									v-if="contestStartTimeMenu"
									v-model="contestData.contestStartTime"
								></v-time-picker>
							</v-menu>
						</v-flex>
						<v-flex xs2/>
					</v-layout>

					<v-layout row wrap>
						<v-flex xs3>
							<v-subheader>Koniec naboru wniosków</v-subheader>
						</v-flex>
						<v-flex xs4>
							<v-menu
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="contestData.contestEndDate"
								full-width
								lazy
								min-width="290px"
								offset-y
								ref="contestEndDateMenu"
								transition="scale-transition"
								v-model="contestEndDateMenu"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										browser-autocomplete="off"
										label="Data zakończenia naboru wniosków"
										aria-label="contest end date"
										for="agency-contest-main-data-date-end-recruitment"
										id="agency-contest-main-data-date-end-recruitment"
										prepend-icon="event"
										readonly
										v-model="contestData.contestEndDate"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									no-title
									scrollable
									:first-day-of-week="1"
									v-model="contestData.contestEndDate"
									locale="pl-PL"
								>
									<v-spacer></v-spacer>
									<v-btn @click="contestEndDateMenu = false" color="primary" flat>Powrót</v-btn>
									<v-btn
										@click="$refs.contestEndDateMenu.save(contestData.contestEndDate)"
										color="blue"
									>OK
									</v-btn>
								</v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex xs4>
							<v-menu
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="contestData.contestEndTime"
								full-width
								lazy
								max-width="290px"
								min-width="290px"
								offset-y
								ref="contestEndTimeMenu"
								transition="scale-transition"
								v-model="contestEndTimeMenu"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										browser-autocomplete="off"
										label="Czas zakończenia naboru wniosków"
										aria-label="contest end time"
										for="agency-contest-main-data-time-end-recruitment"
										id="agency-contest-main-data-time-end-recruitment"
										prepend-icon="access_time"
										readonly
										v-model="contestData.contestEndTime"
										v-on="on"
									></v-text-field>
								</template>
								<v-time-picker
									@click:minute="$refs.contestEndTimeMenu.save(contestData.contestEndTime)"
									format="24hr"
									full-width
									v-if="contestEndTimeMenu"
									v-model="contestData.contestEndTime"
								></v-time-picker>
							</v-menu>
						</v-flex>
						<v-flex xs2/>
					</v-layout>
				</v-flex>

				<v-flex xs6>
					<v-layout row wrap>
						<v-flex xs3>
							<v-subheader>Rok realizacji</v-subheader>
						</v-flex>
						<v-flex xs8>
							<v-select
								:disabled="contestData.open"
								label="Rok realizacji projektów jednorocznych"
								aria-label="project realization year"
								for="agency-contest-main-data-year-completion"
								id="agency-contest-main-data-year-completion"
								:items="realizationYears"
								item-text="value"
								item-value="id"
								v-model="contestData.realizationYearId"
							></v-select>
						</v-flex>
						<v-flex xs2/>
					</v-layout>
					<v-layout row wrap>
						<v-flex xs3>
							<v-subheader>Początek projektu</v-subheader>
						</v-flex>
						<v-flex xs8>
							<v-menu
								ref="projectStartDateMenu"
								v-model="projectStartDateMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="contestData.projectStartDate"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										browser-autocomplete="off"
										v-model="contestData.projectStartDate"
										label="Najwcześniejsza data rozpoczęcia projektu"
										aria-label="project start date"
										for="agency-contest-main-data-earliest-date-start-project"
										id="agency-contest-main-data-earliest-date-start-project"
										prepend-icon="event"
										readonly
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="contestData.projectStartDate"
									no-title
									:first-day-of-week="1"
									scrollable
									locale="pl-PL"
								>
									<v-spacer></v-spacer>
									<v-btn flat color="primary" @click="projectStartDateMenu = false">Powrót</v-btn>
									<v-btn
										color="blue"
										@click="$refs.projectStartDateMenu.save(contestData.projectStartDate)"
									>OK
									</v-btn>
								</v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex xs2/>
					</v-layout>

					<v-layout row wrap>
						<v-flex xs3>
							<v-subheader>Koniec projektu</v-subheader>
						</v-flex>
						<v-flex xs8>
							<v-menu
								ref="projectEndDateMenu"
								v-model="projectEndDateMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="contestData.projectEndDate"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										browser-autocomplete="off"
										v-model="contestData.projectEndDate"
										aria-label="project end date"
										label="Najpóźniejsza data zakończenia projektu"
										for="agency-contest-main-data-latest-date-end-project"
										id="agency-contest-main-data-latest-date-end-project"
										prepend-icon="event"
										readonly
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="contestData.projectEndDate"
									:first-day-of-week="1"
									no-title
									scrollable
									locale="pl-PL"
								>
									<v-spacer></v-spacer>
									<v-btn color="primary" @click="projectEndDateMenu = false">Powrót</v-btn>
									<v-btn
										color="blue"
										@click="$refs.projectEndDateMenu.save(contestData.projectEndDate)"
									>OK
									</v-btn>
								</v-date-picker>
							</v-menu>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>

			<v-layout row wrap class="mt-3">
				<v-flex xs1/>
				<v-flex xs5>
					<v-layout wrap>
						<v-flex xs9>
							<v-subheader>{{contestData.manyTasks ?
								"Wniosek może dotyczyć wielu zadań" :
								"Wniosek może dotyczyć tylko jednego zadania"}}
							</v-subheader>
						</v-flex>
						<v-flex xs3>
							<v-switch aria-label="label for switch"
								v-model="contestData.manyTasks"
							></v-switch>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs5>
					<v-layout wrap>
						<v-flex xs9>
							<v-subheader>{{contestData.manyAccreditationCountries ?
								"Wniosek może dotyczyć wielu krajów" :
								"Wniosek może dotyczyć tylko jednego kraju"}}
							</v-subheader>
						</v-flex>
						<v-flex xs3>
							<v-switch aria-label="label for switch"
								v-model="contestData.manyAccreditationCountries"
							></v-switch>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs1/>
			</v-layout>

			<v-layout row wrap class="mt-1">
				<v-flex xs1/>
				<v-flex xs5>
					<v-layout wrap>
						<v-flex xs9>
							<v-subheader>{{contestData.manyPriorities ?
								"Wniosek może dotyczyć wielu priorytetów" :
								"Wniosek może dotyczyć tylko jednego priorytetu"}}
							</v-subheader>
						</v-flex>
						<v-flex xs3>
							<v-switch aria-label="label for switch"
								v-model="contestData.manyPriorities"
							></v-switch>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs5>
					<v-layout wrap>
						<v-flex xs9>
							<v-subheader>{{contestData.manyAreas ?
								"Wniosek może dotyczyć wielu obszarów" :
								"Wniosek może dotyczyć tylko jednego obszaru"}}
							</v-subheader>
						</v-flex>
						<v-flex xs3>
							<v-switch aria-label="label for switch"
								v-model="contestData.manyAreas"
							></v-switch>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs1/>
			</v-layout>

			<v-layout row wrap class="mt-1">
				<v-flex xs1/>
				<v-flex xs5>
					<v-layout wrap>
						<v-flex xs9>
							<v-subheader>{{contestData.maxProjectLimitPerAgencyEnabled ?
								"Limit wniosków na placówkę jest sprecyzowany" :
								"Limit wniosków na placówkę nie jest sprecyzowany"}}
							</v-subheader>
						</v-flex>
						<v-flex xs3>
							<v-switch aria-label="label for switch"
								v-model="contestData.maxProjectLimitPerAgencyEnabled"
							></v-switch>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs2>
					<v-text-field
						class="ml-3"
						browser-autocomplete="off"
						aria-label="project limit per agency"
						v-if="contestData.maxProjectLimitPerAgencyEnabled"
						v-model="contestData.maxProjectLimitPerAgencyValue"
						label="Limit wniosków"
						type="number"
					></v-text-field>
				</v-flex>
				<v-flex xs4/>
			</v-layout>

			<v-layout row mt-4>
				<v-flex xs2>
					<v-subheader>Hint pod działaniami</v-subheader>
				</v-flex>
				<v-flex xs8>
					<v-textarea
						browser-autocomplete="off"
						style="padding-right: 20px"
						aria-label="activities table hint"
						:outline="true"
						:required="false"
						auto-grow
						type="text" v-model="contestData.activitiesTableHint"></v-textarea>
				</v-flex>
			</v-layout>

			<v-layout row mt-4>
				<v-flex xs2>
					<v-subheader>Hint pod budżetem</v-subheader>
				</v-flex>
				<v-flex xs8>
					<v-textarea
						browser-autocomplete="off"
						style="padding-right: 20px"
						aria-label="financial table hint"
						:outline="true"
						:required="false"
						auto-grow
						type="text" v-model="contestData.financialTableHint"></v-textarea>
				</v-flex>
			</v-layout>
		</v-card-text>
	</v-card>
</template>

<script>
	import {Api} from "../../../api";
	import {AgencyContest} from "../../../api/generated/AgencyContest";
	import {createLabels} from "../../../utils/createLabels";

	export default {
		name: "AgencyContestMainData",
		computed: {
			maxContestStartDate() {
				return this.contestData.contestEndDate;
			},
			minContestEndDate() {
				return this.contestData.contestStartDate;
			},
			maxContestEndDate() {
				return this.contestData.projectStartDate;
			},
			minProjectStartDate() {
				return this.contestData.contestEndDate;
			},
			maxProjectStartDate() {
				return this.contestData.projectEndDate;
			},
			minProjectEndDate() {
				return this.contestData.projectStartDate;
			},
		},

		methods: {
			prepareRequest() {
				if (
					this.contestData.contestStartDate !== null &&
					this.contestData.contestStartTime === null
				) {
					this.contestData.contestStartTime = "00:00";
				}
				if (
					this.contestData.contestEndDate !== null &&
					this.contestData.contestEndTime === null
				) {
					this.contestData.contestEndTime = "00:00";
				}
				if (
					this.contestData.projectStartDate !== null &&
					this.contestData.projectStartTime === null
				) {
					this.contestData.projectStartTime = "00:00";
				}
				if (
					this.contestData.projectEndDate !== null &&
					this.contestData.projectEndTime === null
				) {
					this.contestData.projectEndTime = "00:00";
				}
				if (
					this.contestData.contestStartTime !== null &&
					this.contestData.contestStartDate === null
				) {
					this.contestData.contestStartTime = null;
				}
				if (
					this.contestData.contestEndTime !== null &&
					this.contestData.contestEndDate === null
				) {
					this.contestData.contestEndTime = null;
				}
				if (
					this.contestData.projectStartTime !== null &&
					this.contestData.projectStartDate === null
				) {
					this.contestData.projectStartTime = null;
				}
				if (
					this.contestData.projectEndTime !== null &&
					this.contestData.projectEndDate === null
				) {
					this.contestData.projectEndTime = null;
				}
			},

			save() {
				this.prepareRequest();
				Api.put(this, "/agency-contest/data", this.contestData, () => {
						this.$parent.updateNames(
							this.contestData.name,
							this.contestData.shortName,
						);
						this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane");
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
					});
			},
		},

		data() {
			return {
				contestData: {
					id: this.$route.params.id,
					name: "",
					shortName: "",
					departmentId: "",
					contestStartDate: "",
					contestStartTime: "",
					contestEndDate: "",
					contestEndTime: "",
					legalFormList: [],
					realizationYearId: "",
					projectStartDate: "",
					manyPriorities: false,
					manyTasks: false,
					manyAreas: false,
					projectEndDate: "",
					projectStartTime: "",
					projectEndTime: "",
					contestPage: "",
					maxNumberOfAgencies: undefined,
					manyAccreditationCountries: false,
					open: false,
					new: false,
					maxProjectLimitPerAgencyEnabled: false,
					maxProjectLimitPerAgencyValue: 0,
					activitiesTableHint: "",
					financialTableHint: "",
				},

				contestStartDateMenu: false,
				contestStartTimeMenu: false,
				contestEndDateMenu: false,
				contestEndTimeMenu: false,
				projectStartDateMenu: false,
				projectStartTimeMenu: false,
				projectEndDateMenu: false,
				projectEndTimeMenu: false,

				realizationYears: [],
				legalForms: [],
			};
		},

		created() {
			AgencyContest.getState(this, this.contestData.id,
				response => {
					this.contestData.open = response.agencyContestAnnouncementStatus === "ANNOUNCED";
					this.contestData.new = response.agencyContestAnnouncementStatus === "NEW";
				});
			createLabels.createLabelForMultipleAutocomplete();
		},

		mounted() {
			AgencyContest.getData(this, this.$route.params.id, response => {
				for (let field in response) {
					if (this.contestData.hasOwnProperty(field)) {
						this.contestData[field] = response[field];
					}
				}
			});
			Api.get(this, "/contest-realization-year/list", response => {
				response.items.forEach(element => {
					this.realizationYears.push(element);
					this.realizationYears.sort(function (x, y) {
						return y.value - x.value;
					});
				});
			});
			Api.get(this, "/paragraph/legal-form-paragraph-list", response => {
				response.forEach(element => {
					this.legalForms.push(element.legalForm);
				});
			});
		},
	};
</script>

<style>
	/* Fixed IE problem */
	.save-button {
		display: inline-block;
	}

	.agency-contest .v-input__prepend-outer {
		margin-left: 0;
	}
</style>
